import React from 'react'
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Heading, ExpandableSection } from '@enterprise-ui/canvas-ui-react'
import { AgGridReact } from 'ag-grid-react'
import { ColDef } from 'ag-grid-community'
import { BottomBorderDiv } from './SynergyDivComponent'
import { MultipleReasonCode } from './Queries'

const agGrid = css`
  .ag-cell {
    font-size: 12px !important;
  }
  .ag-header-cell-text {
    font-size: 12px !important;
  }
  .ag-center-cols-viewport {
    min-height: unset !important;
  }
`

const PAGE_SIZE = 10

interface MultipleReasonCodesTableProps {
  multipleReasonCodes?: MultipleReasonCode[]
  showExpander?: boolean
}

const MultipleReasonCodesTable: React.FC<MultipleReasonCodesTableProps> = ({
  multipleReasonCodes,
  showExpander = true,
}) => {
  const rowCount = multipleReasonCodes?.length ?? 0

  if (rowCount === 0) {
    return null
  }

  const columnDefs: ColDef[] = [
    {
      headerName: 'Reason Code Text',
      field: 'reasonCodeText',
      flex: 2,
      minWidth: 150,
      sortable: true,
      filter: false,
      resizable: true,
    },
    {
      headerName: 'Disputed Document Amount ($)',
      field: 'disputedDocumentAmount',
      flex: 1,
      minWidth: 180,
      sortable: true,
      filter: false,
      resizable: true,
      valueFormatter: (params) =>
        params.value != null ? `$${Number(params.value).toFixed(2)}` : 'None',
    },
  ]

  const needsPagination = rowCount > PAGE_SIZE

  const grid = (
    <div css={agGrid} className="ag-theme-alpine">
      <AgGridReact
        defaultColDef={{
          sortable: true,
          flex: 1,
          filter: false,
          minWidth: 100,
          resizable: true,
        }}
        rowData={multipleReasonCodes}
        columnDefs={columnDefs}
        domLayout={needsPagination ? 'normal' : 'autoHeight'}
        pagination={needsPagination}
        paginationPageSize={PAGE_SIZE}
        {...(needsPagination ? { style: { height: '300px' } } : {})}
      />
    </div>
  )

  return (
    <BottomBorderDiv>
      <div className="hc-pa-normal hc-pl-none hc-pr-none hc-pt-none">
        {showExpander ? (
          <ExpandableSection startExpanded toggleLocation="left" padding="none">
            <Heading size={6}>Cover Letter details:</Heading>
            <ExpandableSection.Content className="hc-pl-lg hc-pv-normal">
              {grid}
            </ExpandableSection.Content>
          </ExpandableSection>
        ) : (
          <>
            <Heading size={6}>Cover Letter details:</Heading>
            <div className="hc-pv-normal">{grid}</div>
          </>
        )}
      </div>
    </BottomBorderDiv>
  )
}

export default MultipleReasonCodesTable
